// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getToken } from "../utils";

// initialize an empty api service that we'll inject endpoints into later as needed
// eslint-disable-next-line import/prefer-default-export
export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
    headers: { Authorization: `Bearer ${getToken()}` },
  }),
  endpoints: () => ({}),
});
